import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ old_password: '', new_password: '', confirm: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const errs = {};
    if (!form.old_password) errs.old_password = 'Required';
    if (!form.new_password || form.new_password.length < 6) errs.new_password = 'Minimum 6 characters';
    if (form.new_password !== form.confirm) errs.confirm = 'Passwords do not match';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await authAPI.changePassword({ old_password: form.old_password, new_password: form.new_password });
      toast.success('Password changed successfully.');
      navigate(-1);
    } catch (err) {
      const msg = err.response?.data?.old_password?.[0] || err.response?.data?.detail || 'Failed.';
      toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <div className="page-container">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 28 }}>
        <button className="btn-icon magenta" onClick={() => navigate(-1)}
          style={{ width: 34, height: 34, borderRadius: '50%', background: 'var(--magenta)', color: 'var(--white)' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
          </svg>
        </button>
        <h1 style={{ fontSize: 22, fontWeight: 700 }}>Change Password</h1>
      </div>

      <div className="card" style={{ maxWidth: 420, padding: 32 }}>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {[
            { label: 'Current Password', key: 'old_password' },
            { label: 'New Password', key: 'new_password' },
            { label: 'Confirm New Password', key: 'confirm' },
          ].map(f => (
            <div key={f.key} className="form-group">
              <label className="form-label">{f.label}</label>
              <input
                className={`form-input${errors[f.key] ? ' error' : ''}`}
                type="password" value={form[f.key]}
                onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))}
              />
              {errors[f.key] && <span className="form-error">{errors[f.key]}</span>}
            </div>
          ))}
          <button type="submit" className="btn btn-primary" disabled={loading}
            style={{ width: '100%', justifyContent: 'center', padding: 12 }}>
            {loading ? <><span className="spinner" style={{ width: 15, height: 15 }} /> Saving…</> : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
